window.onload = function () {
  if (window.readMoreInitialized) {
    return;
  }

  window.readMoreInitialized = true;

  Array.from(document.querySelectorAll('.js-btn-read-more')).forEach(btn => {
    btn.addEventListener('click', e => {
      e.target.parentNode.classList.add('active');
    });
  });
};
